/* This example requires Tailwind CSS v2.0+ */

import { ChartSquareBarIcon, UserGroupIcon } from '@heroicons/react/outline';
import useLocale from 'next-translate/useTranslation';

const options = [
  {
    name: 'Join the Program',
    type: 'signup',
    description: 'Sign up for our affiliate program to start earning.',
  },
  {
    name: 'Share Your Link',
    type: 'share',
    description:
      'Use your unique affiliate link to refer customers to our services.',
  },
  {
    name: 'Earn Commissions',
    type: 'earn',
    description:
      'Earn a commission for every customer who signs up through your link.',
  },
];

const features = [
  {
    name: 'Engage your audience',
    description:
      'Dive into the world of artificial intelligence and share the wonders of Easy-Peasy.AI with your audience.',
    icon: ChartSquareBarIcon,
  },
  {
    name: 'Earn your 30%',
    description:
      'Get a recurrent 30% commission every single month, sent straight to your PayPal.',
    icon: UserGroupIcon,
  },
];

export default function TranscriptionFeaturesAffil() {
  const { t } = useLocale('affiliates');

  return (
    <section>
      <div className='bg-white py-12 dark:bg-slate-900'>
        <div className='mx-auto max-w-xl px-4 text-center sm:px-6 lg:max-w-7xl lg:px-8'>
          <h2 className='mx-auto mt-2 max-w-3xl text-center text-3xl font-bold tracking-tight text-gray-900 dark:text-slate-200 sm:text-4xl'>
            {t('How the Affiliate Program works')}
          </h2>
          <p className='mx-auto mt-5 max-w-prose text-xl text-gray-500 dark:text-slate-400'>
            {t('Three easy steps to get your constant passive income')}
          </p>
          <dl className='mt-12 space-y-10 text-center lg:grid lg:grid-cols-3 lg:gap-8 lg:space-y-0'>
            {options.map((feature) => (
              <div key={feature.name}>
                <dt className='text-center'>
                  <div className='mx-auto flex h-12 w-12 items-center justify-center rounded-md bg-indigo-500 text-white'>
                    <span className='text-lg font-bold'>
                      {options.indexOf(feature) + 1}
                    </span>
                  </div>
                  <strong className='mt-5 block text-lg font-medium leading-6 text-gray-900 dark:text-slate-300'>
                    {t(feature.name)}
                  </strong>
                </dt>
                <dd className='mt-2 text-base text-gray-500'>
                  {t(feature.description)}
                </dd>
              </div>
            ))}
          </dl>
        </div>
      </div>

      <div className='bg-white dark:bg-slate-900 lg:py-24'>
        <div className='mx-auto max-w-7xl px-6 lg:px-8'>
          <div className='flex flex-wrap justify-between'>
            <div className='flex w-full justify-center px-6 lg:w-1/2 lg:justify-start'>
              <video
                autoPlay
                style={{
                  maxWidth: '70%',
                  height: 'auto',
                  borderRadius: '37px',
                  objectFit: 'cover',
                  marginBottom: '40px',
                  backgroundColor: 'rgba(0, 0, 0, 0)',
                }}
                muted
                playsInline
                controls
                src='https://media.easy-peasy.ai/static/workshop/alexxmarketing.mp4'
              ></video>
            </div>
            <div className='w-full lg:w-1/2'>
              <h3 className='text-3xl font-bold tracking-tight text-gray-900 dark:text-slate-200 sm:text-4xl'>
                {t('Welcome to the land of endless earnings!')}
              </h3>
              <p className='mt-4 text-lg text-gray-500 dark:text-slate-400'>
                {t(
                  'Are you ready to elevate your earning game and explore an exciting opportunity that blends innovation with rewards? Join us at Easy-Peasy.AI as an affiliate partner and embark on a journey where your success is our priority.'
                )}
              </p>

              <div className='mt-12 lg:col-span-2 lg:mt-12'>
                <dl className='space-y-10 sm:grid sm:grid-flow-col sm:grid-cols-2 sm:grid-rows-3 sm:gap-x-6 sm:gap-y-10 sm:space-y-0 lg:gap-x-8'>
                  {features.map((feature) => (
                    <div key={feature.name} className='relative'>
                      <dt>
                        <feature.icon
                          className='absolute h-6 w-6 text-primary-500'
                          aria-hidden='true'
                        />
                        <p className='ml-9 text-lg font-medium leading-6 text-gray-900 dark:text-slate-200'>
                          {t(feature.name)}
                        </p>
                      </dt>
                      <dd className='ml-9 mt-2 text-base text-gray-500 dark:text-slate-400'>
                        {t(feature.description)}
                      </dd>
                    </div>
                  ))}
                </dl>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
